import { ClassProvider } from '@angular/core';
import { AggregatorAdapter, AggregatorProcessApiService } from '../services';

export function provideProcessAggregatorApi(): ClassProvider {
  return {
    provide: AggregatorAdapter,
    useClass: AggregatorProcessApiService,
  };
}
